import { OffsetOptions } from '@floating-ui/react';

import { Popover } from '../..';
import { PopoverProps } from '../popover/popover.types';

export interface TooltipProps {
  title: React.ReactNode;
  children: React.ReactNode;
  placement?: PopoverProps['placement'];
  /**
   * DEPRECATED. arrow always points at the center of the anchor element
   */
  arrowPointAtCenter?: boolean;
  className?: string;
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
  overlayInnerStyle?: React.CSSProperties;
  innerContentClassName?: string;
  autoPlacementOptions?: PopoverProps['autoPlacementOptions'];
  containerClassName?: string;
  offsetOptions?: OffsetOptions;
  showArrow?: PopoverProps['showArrow'];
}

const innerStyles = 'text-white text-sm leading-6 py-1.5 px-2 bg-gray-900 rounded-lg border-none overflow-hidden';

export function Tooltip({ placement = 'bottom-start', arrowPointAtCenter = false, ...props }: TooltipProps) {
  const { innerContentClassName = '', title, ...rest } = props;

  return (
    <Popover
      arrowFill="#212121" //bg-gray-900
      trigger="hover"
      enabled={!!title}
      content={title}
      role="tooltip"
      transitionDuration={250}
      innerContentClassName={`${innerStyles} ${innerContentClassName}`}
      placement={placement}
      arrowPointAtCenter={arrowPointAtCenter}
      {...rest}
    />
  );
}

export default Tooltip;
